import _ from 'underscore'

const mutations = {
  auth (state) {
    state.isLoading = true
    state.hasError = false
    state.errorMessage = ''
  },
  authSuccess (state) {
    state.isLoading = false
  },
  authError (state, errorMessage) {
    state.isLoading = false
    state.hasError = true
    state.errorMessage = errorMessage
    state.questions = []
    state.stepDescriptions = []
    state.totalSteps = 0
  },
  storeAnswers (state) {
    state.isLoading = true
    state.hasError = false
    state.errorMessage = ''
  },
  pullFactorsNotReceived (state) {
    state.pullFactorsReceived = false
  },
  
  storeAnswersSuccess (state) {
    state.hasError = false
    state.isLoading = false
    state.isComplete = true
  },

  storeAnswersError (state) {
    state.isLoading = false
    state.hasError = true
  },

  addFollowUpQuestion (state, question) {
    state.followUpQuestions.push(question)
  },

  clearFollowUpQuestions (state) {
    state.followUpQuestions = []
  },

  clearValidationErrors (state) {
    state.wrongAnsweredQuestions = []
  },

  setValidationErrors (state, wrongAnsweredQuestions) {
    state.wrongAnsweredQuestions = wrongAnsweredQuestions
  },

  nextStep (state) {
    state.currentStep++
  },

  storeAnswer (state, newAnswer) {
    state.answers.push(newAnswer)
  },

  updateAnswer (state, newAnswer) {
    state.answers.map((answer) => {
      if (answer.question_id === +newAnswer.question_id) {
        return newAnswer
      }
      return answer
    })
  },
  setIncomplete(state){
    state.isComplete = false
  },
  previousStep (state) {
    if (state.followUpQuestions.length) {
      state.followUpQuestions = []
    } else {
      state.currentStep--
    }
  },
  getQuestions (state) {
    state.errorMessage = ''
    state.isLoading = true
    state.hasError = false
    state.questions = []
  },

  getQuestionsError (state) {
    state.hasError = true
    state.isLoading = false
    state.errorMessage = 'Er is iets misgegaan bij het ophalen van de vragen'
  },

  getQuestionsSuccess (state, questions) {
    state.questions = questions
    state.isLoading = false
  },

  getQuestionTypes (state) {
    state.errorMessage = ''
    state.isLoading = true
    state.hasError = false
    state.questionTypes = []
  },

  getQuestionTypesError (state) {
    state.hasError = true
    state.isLoading = false
    state.errorMessage = 'Er is iets misgegaan bij het ophalen van de vraagtypes'
  },

  getQuestionTypesSuccess (state, questionTypes) {
    state.questionTypes = questionTypes
    state.isLoading = false
  },

  getPullFactors (state) {
    state.isLoading = true
    state.errorMessage = ''
    state.hasError = false
  },

  getPullFactorsSuccess (state, data) {
    state.isLoading = false
    state.pullFactorsReceived = true

    state.questions = _.map(state.questions, (question) => {
      // fill pull factor question options
      if (question.type === 'pullfactor') {
        question.extraAttributes.questionOptions = []
        _.each(data.pullfactors, (pullfactor, key) => {
          
          // add the follow up pullfactor questions
          let foundQuestion = _.find(state.questions, (row) => {
            return pullfactor.label === row.extraAttributes.questionAttributes['pullfactor_name']
          })
          let additionalQuestionId = 0
          if (typeof foundQuestion !== 'undefined') {
            additionalQuestionId = foundQuestion.id
          }
          
          question.extraAttributes.questionOptions.push({
            id: key,
            additional_question_id: additionalQuestionId,
            option_label: pullfactor.label,
            option_value: pullfactor.label,
            question_id: question.id,
            sort_order: 0
          })
        })
      }

      // fill orientation terms question options
      if (question.type === 'orientation_points') {
        question.extraAttributes.questionOptions = []
        _.each(data.orientation_terms, (orientationTerm, key) => {

          // add the follow up pullfactor questions
          let foundQuestion = _.find(state.questions, (row) => {
            return orientationTerm.label === row.extraAttributes.questionAttributes['pullfactor_name']
          })
          let additionalQuestionId = 0
          if (typeof foundQuestion !== 'undefined') {
            additionalQuestionId = foundQuestion.id
          }
          
          question.extraAttributes.questionOptions.push({
            id: key,
            additional_question_id: additionalQuestionId,
            option_label: orientationTerm.label,
            option_value: orientationTerm.label,
            question_id: question.id,
            sort_order: 0
          })
        })
      }
      return question
    })
  },

  getPullFactorsError (state) {
    state.isLoading = false
    state.hasError = true
    state.errorMessage = 'Er is iets misgegaan bij het ophalen van de pullfactoren'
  },
  getQuestionStepDescriptions (state) {
    state.errorMessage = ''
    state.isLoading = true
    state.hasError = false
    state.stepDescriptions = []
  },

  getQuestionStepDescriptionsError (state) {
    state.hasError = true
    state.isLoading = false
    state.errorMessage = 'Er is iets misgegaan bij het ophalen van de stap omschrijvingen'
  },

  getQuestionStepDescriptionsSuccess (state, stepDescriptions) {
    state.stepDescriptions = stepDescriptions
    state.isLoading = false
  },

  setCredentials (state, credentials) {
    state.intakeId = +credentials.intakeId;
    state.token = credentials.token;
  },

  isMobile (state) {
    state.isMobile = true
  },

  isDesktop (state) {
    state.isMobile = false
  },
  
  clearState (state) {
    state.intakeId = null
    state.token = null
    state.currentStep = 1
    state.questions = []
    state.questionTypes = []
    state.stepDescriptions = []
    state.wrongAnsweredQuestions = []
    state.followUpQuestions = []
    state.answers = []
    state.totalSteps = 0
    state.hasError = false
    state.errorMessage = ''
    state.isLoading = false
    state.isComplete = false
    state.isMobile = false
    state.pullFactorsReceived = false
  },

  addPossibleFunctionNames (state, functionName) {
    state.possibleFunctionNames.push(functionName)
  }
}

export default mutations
